import "./CouncilsAndPublicSector.module.css";
import Header from "@/reusable_sections/Header";
import PublicSector from "./sections/PublicSector";
import Partnership from "./sections/Partnership";
import Footer from "@/reusable_sections/Footer";
export default function CouncilsAndPublicSectorPage() {
  return <div>
      <Header />
      <PublicSector />
      <Partnership />
      <Footer />
    </div>;
}